<template>
  <button tabindex="0" class="nav-button">
    <div class="nav-button-content">
      <div class="icon" v-if="icon">
        <img :src="icon" alt="icon" />
      </div>
      <slot></slot>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.icon {
  width: 20px;
  height: 16px;
  color: #0b9096;
}
.nav-button {
  background: transparent;
  border: none;
  padding: 0;
  border: none;
  color: #0b9096;
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;

  &-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &:focus-visible {
    outline: 1px solid #000000;
    outline-offset: 2px;
    border-radius: 2px;
  }
  &:hover {
    color: var(#0b7a7e);
    cursor: pointer;
    .icon {
      color: #0b7a7e;
    }
  }
  &:active {
    color: var(--color-primary-40);
  }
}
</style>
